export interface MapBounds {
  north: number
  west: number
  south: number
  east: number
}

export type BoundsByKey = Map<string, Array<[number, number]>>

export const useFeatureBounds = (overwriteBounds?: Ref<BoundsByKey>) => {
  const boundsByKey = overwriteBounds ?? ref<BoundsByKey>(new Map())

  const bounds = computed(() => {
    const allBounds: Array<[number, number]> = []

    boundsByKey.value.forEach((boundsForKey) => {
      allBounds.push(...boundsForKey)
    })

    return allBounds.reduce<MapBounds>(
      (totalBounds, [lat, lon]) => {
        if (lat > totalBounds.north) totalBounds.north = lat
        if (lat < totalBounds.south) totalBounds.south = lat
        if (lon > totalBounds.east) totalBounds.east = lon
        if (lon < totalBounds.west) totalBounds.west = lon

        return totalBounds
      },
      {
        north: -Infinity,
        east: -Infinity,
        south: Infinity,
        west: Infinity,
      },
    )
  })

  const resetBounds = (keys?: Array<string>) => {
    if (!keys) {
      boundsByKey.value = new Map()
      return
    }

    keys.forEach((key) => {
      boundsByKey.value.delete(key)
    })
  }

  const updateBounds = (key: string, lat: number, lon: number) => {
    const existingBounds = boundsByKey.value.get(key)

    if (!existingBounds) {
      boundsByKey.value.set(key, [[lat, lon]])
      return
    }

    existingBounds.push([lat, lon])
  }

  return {
    bounds,
    boundsByKey,
    resetBounds,
    updateBounds,
  }
}
